import React from "react";
import img1 from "../images/location.png";
import img2 from "../images/phone.png";
import img3 from "../images/email.png";
import img4 from "../images/whatsapp.png";
import img5 from "../images/instagram.png";
import img6 from "../images/facebook.png";
import img7 from "../images/youtube.png";
import Map from "./Map"; // Assuming you have a Map component for displaying the map

const Contact = () => {
  return (
    <div className=" 3xl:flex justify-center items-center ">
      <div className="lg:flex  3xs:px-2 2xs:px-4 xs:px-8 sm:px-14 md:px-20  xl:px-24 3xl:px-8 5xl:px-10 6xl:px-16 py-7 xl:py-8  8xl:px-20 9xl:px-48 ">
        <div className="bg-secondary 5xl:flex justify-center items-center rounded-3xl 3xl:rounded-none lg:w-[400px]   xl:w-[630px] xl:h-[460px] 3xl:w-[400px] 4xl:w-[450px] 4xl:h-[470px] 5xl:w-[520px] 5xl:h-[350px] 6xl:w-[580px] 7xl:w-[600px] 8xl:w-[670px] 8xl:h-[480px] 9xl:w-[780px] 9xl:h-[470px] 10xl:w-[900px] 10xl:h-[520px] 11xl:w-[1330px] 11xl:h-[850px] py-6 5xl:py-4">
          <div>
            <div className=" font-sans 5xl:flex justify-center  lg:gap-7 text-md   text-[#FFBE00] font-semibold text-center">
              <div>
                <img
                  className="w-[30px] sm:w-10  7xl:w-[40px]  mb-2 mx-auto"
                  src={img1}
                  alt="pattu"
                />
                
               <a href="https://maps.app.goo.gl/LJGfWvn2wdYfqVjk6" className="cursor-pointer">
    <p>12/1, Thalaiyari street,</p>
    <p>Thirubuvanam-612103</p>
    <p className="mb-5 5xl:mb-0">Kumbakonam</p>
</a>

                
              </div>
              <div>
                <img
                  className="w-[30px] sm:w-10 7xl:w-[40px] mb-2 mx-auto"
                  src={img2}
                  alt="pattu"
                />
                <a
                  href="https://api.whatsapp.com/send?phone=919385572362"
                  className=" hover:underline "
                >
                  9790525353
                </a>
                <p className=" mb-5 ">
                  <a className="" href="tel:+917397193009">
                    7397193009
                  </a>
                </p>
              </div>
              <div>
                <img
                  className="w-[30px] sm:w-10 7xl:w-[40px] mt-2 5xl:mt-0 mb-2 mx-auto"
                  src={img3}
                  alt="pattu"
                />
                <p className="mb-5 5xl:mb-0 ">prsilks001@gmail.com</p>
              </div>
            </div>

            <div className="mt-2 text-center">
              <h1 className="text-[#FFBE00] sm:text-md text-lg font-bold">
                Follow Us
              </h1>
              <div className="flex justify-center gap-4 mt-3">
                <a href="https://api.whatsapp.com/send?phone=919385572362">
                  <img className="w-7 h-7" src={img4} alt="WhatsApp" />
                </a>
                <a href="https://www.instagram.com/thirubuvanam_silk_society_p.r_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                  <img className="w-7 h-7" src={img5} alt="Instagram" />
                </a>
                <a href="https://www.facebook.com/share/1ZX5rzEEor/">
                  <img
                    className="w-7 h-7 font-bold"
                    src={img6}
                    alt="Facebook"
                  />
                </a>
                <a href="https://www.youtube.com/@P.R.Silksthirubuvanam">
                  <img className="w-7 h-7" src={img7} alt="YouTube" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className=" 3xl:block hidden lg:w-[500px] 3xl:w-[300px] 4xl:w-[350px] 5xl:w-[400px] 6xl:w-[470px] 7xl:w-[520px] 8xl:w-[650px] 9xl:w-[700px] 9xl:h-[470px] 10xl:w-[750px] 10xl:h-[520px] 11xl:w-[1300px] 11xl:h-[850px] ">
          <Map />
        </div>
      </div>
    </div>
  );
};

export default Contact;
